import { NgFor, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TimesPipe } from '../../../pipes/times.pipe';

@Component({
  selector: 'app-skeleton-loaders',
  imports: [NgSwitch, NgSwitchCase, TimesPipe, NgFor],
  templateUrl: './skeleton-loaders.component.html',
  styleUrl: './skeleton-loaders.component.css'
})
export class SkeletonLoadersComponent {
@Input() case: string = '';
@Input() items: number = 1;
  priceCount : number = 4;
}
